import { AtsConversationMessageFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { isBackendDateTimeInFuture } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

// TODO: move topics to backend
export type AtsMessageTopics = 'message' | 'sent_offer_letter' | 'declined_offer_letter'

export const isMessageDelayed = (message: AtsConversationMessageFragment) =>
  message.delayedUntil ? isBackendDateTimeInFuture(message.delayedUntil) : false

export const isDeclinedOfferTopic = (message: AtsConversationMessageFragment) => {
  return message.topic === 'declined_offer_letter'
}

export const isSentOfferTopic = (message: AtsConversationMessageFragment) => {
  return message.topic === 'sent_offer_letter'
}

export const CUSTOM_DELAY_VALUE = 'custom'

export const useMessageOptions = () => {
  const isBeforeTodayAtSix = moment().isBefore(moment().startOf('day').hour(18))

  const defaultOption = {
    label: i18n.t('common.select_basic'),
    value: null,
  }

  const fallbackOption = {
    label: i18n.t('ats.candidates.messages.delayed_messages.send_now'),
    value: 'now',
  }

  const sendMessageOptions = [
    {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_later_2_hours'),
      value: 'two_hours',
    },
    {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_later_4_hours'),
      value: 'four_hours',
    },
    {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_later_6_hours'),
      value: 'six_hours',
    },
    {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_tomorrow'),
      value: 'tomorrow_at_nine_am',
    },
    {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_next_monday'),
      value: 'next_monday_at_nine_am',
    },
  ]

  isBeforeTodayAtSix &&
    sendMessageOptions.splice(3, 0, {
      label: i18n.t('ats.candidates.messages.delayed_messages.send_today_6_pm'),
      value: 'today_at_six_pm',
    })

  const customOption = {
    label: i18n.t('ats.candidates.messages.delayed_messages.schedule'),
    value: CUSTOM_DELAY_VALUE,
  }

  return {
    customOption,
    defaultOption,
    fallbackOption,
    isBeforeTodayAtSix,
    sendMessageOptions,
  }
}
